// App
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

// Hooks
import { useFilterChange } from 'app/shared/modules/filter/FilterBar/hooks';

// Components
import { SortDescendingIcon } from 'app/shared/halo/components/ui/icons/SortDescendingIcon';

// Tracking
import { emitTrackSortListingsEvent } from 'app/shared/models/Clickstream/ListingsClickstreamEvents';

// Styles
import * as S from './styles';

const SORT_LABELS: Record<string, string> = {
  '': 'Recommended',
  activated: 'Newest',
  weekViews: 'Most popular',
  highPrice: 'High price',
  lowPrice: 'Low price',
};

const SortButton = () => {
  const orderByState = useSelector((state: RootReduxState) => state.filter.orderBy);
  const { filterChange } = useFilterChange();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const option = e.target.value;
    filterChange({ orderBy: option });

    emitTrackSortListingsEvent({
      triggerLocation: 'search_results',
      triggerObject: 'search_results|header',
    });
  };

  return (
    <S.SortWrapper>
      <SortDescendingIcon size={16} />
      <S.SortLabel>{SORT_LABELS[orderByState] ?? 'Recommended'}</S.SortLabel>
      <S.HiddenSelect value={orderByState} onChange={handleChange} aria-label="Sort listings">
        {Object.entries(SORT_LABELS).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </S.HiddenSelect>
    </S.SortWrapper>
  );
};

export default SortButton;
